export default function isAuthenticatedSession({ authToken, userData }) {
  return Boolean(authToken && userData);
}
